import React, { useEffect, useState } from "react";
import { Table, Input, Button, DatePicker, Space, Tag } from "antd";
import dayjs from "dayjs";
import { useParams } from "react-router-dom";
import api from "../../../../api";
import { useToast } from "../../../../components/toast/toast";

const { RangePicker } = DatePicker;

const LotteryNumbersPage = ({ trigger, activeKey }) => {
  const { id: lotteryId } = useParams();

  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    draw_range: [],
    phoneNumber: "",
  });
  const toast = useToast();

  const columns = [
    {
      title: "Төлөв",
      dataIndex: "active",
      key: "active",
      width: 200,
      render: (val) => <Tag color="blue">{val ? "Идэвхтэй" : "Идэвхгүй"}</Tag>,
    },
    {
      title: "Дугаар",
      dataIndex: "number",
      key: "number",
      width: 100,
    },
    {
      title: "Order",
      dataIndex: "order",
      key: "order",
      width: 100,
    },
    {
      title: "Зарагдсан эсэх",
      dataIndex: "is_sold",
      key: "is_sold",
      width: 120,
      render: (val) => (val ? "Тийм" : "Үгүй"),
    },
    {
      title: "Утас",
      key: "phone",
      dataIndex: "LotteryTicket",
      width: 120,
      render: (ticket) => ticket?.phone_number || "-",
    },
    {
      title: "Үүсгэсэн огноо",
      dataIndex: "created_at",
      key: "created_at",
      width: 200,
      render: (val) => dayjs(val).format("YYYY-MM-DD HH:mm"),
    },
  ];

  const handleTableChange = (pag) => {
    setPagination((prev) => ({
      ...prev,
      current: pag.current,
      pageSize: pag.pageSize,
    }));
  };

  const fetchData = async () => {
    if (!lotteryId) return;
    setLoading(true);
    const params = {
      page: pagination.current,
      pageSize: pagination.pageSize,
    };

    if (filters.draw_range.length === 2) {
      params.startDate = dayjs(filters.draw_range[0]).format("YYYY-MM-DD");
      params.endDate = dayjs(filters.draw_range[1]).format("YYYY-MM-DD");
    }

    if (filters.phoneNumber) {
      params.phoneNumber = filters.phoneNumber;
    }

    const res = await api.get_lottery_numbers(lotteryId, params);

    // console.log("number List  -->", res);

    const { pagination: pagi } = res.data;

    if (res.data.status === 200) {
      setData(res.data.data);
      setPagination((prev) => ({
        ...prev,
        current: pagi.page,
        pageSize: pagi.pageSize,
        total: pagi.total,
      }));
    } else {
      toast(res.data.message || "Алдаа гарлаа", "error");
    }
    setLoading(false);
  };

  useEffect(() => {
    if (activeKey === "1" && lotteryId) {
      fetchData();
    }
  }, [
    lotteryId,
    pagination.current,
    pagination.pageSize,
    filters,
    trigger,
    activeKey,
  ]);

  return (
    <div>
      <Space style={{ marginBottom: 16 }}>
        {/* <RangePicker
          allowEmpty={[true, true]}
          value={filters.draw_range}
          onChange={(dates) => {
            setFilters((prev) => ({
              ...prev,
              draw_range: dates || [],
            }));
            setPagination((prev) => ({ ...prev, current: 1 }));
          }}
          style={{ height: "32px" }}
        /> */}
        <Input
          placeholder="Утасны дугаар хайх"
          value={filters.phoneNumber}
          onChange={(e) => {
            const val = e.target.value;
            setFilters((prev) => ({ ...prev, phoneNumber: val }));
            setPagination((prev) => ({ ...prev, current: 1 }));
          }}
          // onSearch={(val) => {
          //   setPagination((prev) => ({ ...prev, current: 1 }));
          //   fetchData();
          // }}
          style={{ width: 200 }}
        />
        <Button
          onClick={() => {
            setFilters({ draw_range: [], phoneNumber: "" });
            setPagination((prev) => ({ ...prev, current: 1 }));
          }}
        >
          Цэвэрлэх
        </Button>
      </Space>

      <Table
        columns={columns}
        rowKey="id"
        dataSource={data}
        loading={loading}
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: pagination.total,
          showSizeChanger: true,
          pageSizeOptions: ["5", "10", "20", "50"],
          showTotal: (total) => `Нийт ${total} үр дүн`,
        }}
        onChange={handleTableChange}
      />
    </div>
  );
};

export default LotteryNumbersPage;
